import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

interface Props {
  children: ReactNode;
}

export default function AuthGate({ children }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <p className="p-4 text-center">Laddar…</p>;
  if (!user) {
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
